<template>
    <!--<trend
        :data="retentionHistory.map((e) => e.teacher * 100)"
        :gradient="['#6fa8dc', '#42b983', '#2c3e50']"
        auto-draw
        smooth
    >
    </trend>-->
    <div>
        <apexchart
            height="300"
            :options="{
                grid: {
                    show: true,
                },
                fill: {
                    type: 'solid',
                },
                dataLabels: {
                    enabled: false,
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2,
                    },
                },
                stroke: {
                    curve: 'smooth',
                    width: 4,
                },
                legend: {
                    show: true,
                },
                xaxis: {
                    categories: chartData.map((e) => e.date),
                    labels: {
                        show: true,
                    },
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    tickAmount: 5,
                    labels: {
                        show: true,
                    },
                },
                colors: ['#228cbd', '#f38c68'],
            }"
            :series="[
                {
                    name: 'Leads',
                    data: chartData
                        .map((e) =>
                            e.report.filter((data) => data.key == 'leads')
                        )
                        .flat()
                        .map((e) => e.value),
                    type: 'area',
                },
                {
                    name: 'System',
                    data: chartData
                        .map((e) =>
                            e.report.filter((data) => data.key == 'leads')
                        )
                        .flat()
                        .map((e) => e.system_median),
                    type: 'line',
                },
            ]"
        ></apexchart>
    </div>
</template>

<script>
export default {
    props: {
        chartData: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
